export default class ValdiationFormArcGIS {
  constructor(zipFile) {
    this.zipFile = zipFile;

    this.attributes = ["ESRI3DO_OX", "ESRI3DO_OY", "ESRI3DO_OZ"];
  }

  async validate() {
    const containjson = this.containJSON(this.zipFile);
    const containprj = this.containPRJ(this.zipFile);

    // Contain PRJ and JSON
    if (containjson && containprj) {
      const checkEPGS = await this.containEPGSatribut(this.zipFile);
      const validJSON = await this.checkIfJSONcontainXYZ(this.zipFile);

      if (checkEPGS) {
        const checCoordinates = await this.checkCoordinationSystem(
          this.zipFile
        );

        if (checCoordinates) {
          if (validJSON) {
            const isZero = await this.checkIfZisZero(this.zipFile);

            if (isZero) {
              // ✅ warning - insert glb file to the web scene from ArcGIS
              return {
                kind: "warning",
                message: "ziszero",
                from: "ArcGIS",
              };
            } else {
              // ✅ Succes - insert glb file to the web scene from ArcGIS
              return {
                kind: "success",
                message: "inserttolayerlist",
                from: "ArcGIS",
              };
            }
          } else {
            // ❌ Danger - Invalid JSON
            return {
              kind: "danger",
              message: "invalidjson",
            };
          }
        } else {
          if (validJSON) {
            // ❌ Danger - Unsapported cordination system
            return {
              kind: "danger",
              message: "invalidcoordinate",
            };
          } else {
            // ❌ Danger - Invalid coordinates and JSON
            return {
              kind: "danger",
              message: "invalidcoordinateandjson",
            };
          }
        }
      } else {
        if (validJSON) {
          // ❌ Danger - Invalid coordinates and JSON
          return {
            kind: "danger",
            message: "notContainEPSGatributs",
          };
        } else {
          // ❌ Danger - Invalid coordinates and JSON
          return {
            kind: "danger",
            message: "notContainEPSGatributsInvalidJSON",
          };
        }
      }
    } else if (containjson === false && containprj === false) {
      // ❌ Danger - Not contain JSON and PRJ
      return {
        kind: "danger",
        message: "notcontainprjandjson",
      };
    } else if (!containjson) {
      // ❌ Danger - Not contain JSON
      return {
        kind: "danger",
        message: "notcontainjson",
      };
    } else if (!containprj) {
      // ❌ Danger - Not contain PRJ
      return {
        kind: "danger",
        message: "notcontainprj",
      };
    }
  }
  containJSON(zipFiles) {
    const findByExt = (ext) =>
      zipFiles.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));
    const csvEntery = findByExt(".json");
    if (csvEntery) {
      return true;
    } else {
      return false;
    }
  }
  containPRJ(zipFiles) {
    const findByExt = (ext) =>
      zipFiles.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));
    const csvEntery = findByExt(".prj");
    if (csvEntery) {
      return true;
    } else {
      return false;
    }
  }

  async containEPGSatribut(zipFiles) {
    const findByExt = (ext) =>
      zipFiles.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));
    const prjEntery = findByExt(".prj");
    const parsePrj = await prjEntery.async("string");
    const match = parsePrj.match(/AUTHORITY\["EPSG"\s*,\s*(\d+)\]/);
    if (match) {
      return true;
    } else {
      return false;
    }
  }

  async checkCoordinationSystem(zipFiles) {
    const findByExt = (ext) =>
      zipFiles.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));
    const prjEntery = findByExt(".prj");
    const parsePrj = await prjEntery.async("string");
    const match = parsePrj.match(/AUTHORITY\["EPSG"\s*,\s*(\d+)\]/);
    const epsgCode = parseInt(match[1], 10); // číslo 4326
    if (epsgCode === 4326) {
      return true;
    } else {
      return false;
    }
  }

  async checkIfZisZero(zipFiles) {
    const findByExt = (ext) =>
      zipFiles.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));
    const jsonEntry = findByExt(".json");
    const jsonText = await jsonEntry.async("string"); // UTF-8 text
    const jsonData = JSON.parse(jsonText);

    if (jsonData.attributes.ESRI3DO_OZ == 0) {
      return true;
    } else {
      return false;
    }
  }

  async checkIfJSONcontainXYZ(zipFiles) {
    const findByExt = (ext) =>
      zipFiles.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));
    const jsonEntry = findByExt(".json");
    const jsonText = await jsonEntry.async("string"); // UTF-8 text
    const jsonData = JSON.parse(jsonText);

    function hasKey(obj, key) {
      return typeof obj[key] !== "undefined";
    }

    function hasKeys(obj, keys) {
      for (var i = 1, len = keys.length; i < len; i++) {
        if (!hasKey(obj, keys[i])) {
          return false;
        }
      }
      return true;
    }

    const validJSON = hasKeys(jsonData.attributes, this.attributes);

    if (validJSON) {
      return true;
    } else {
      return false;
    }
  }
}
